(function(angular){
	'use strict';
	
	angular
		.module('highChartsModule', [])
		.value('Highcharts', Highcharts)
		.constant('HIGHCHARTS_OPTIONS', highChartsOptionsFunction)
		.constant('HIGHCHARTS_SERIES_COLORS', [
			'hsl(210,100%,40%)', '#878C92'
		]);

	function highChartsOptionsFunction(theme){
		var dataLabelColor;
		var lineColor;
		var labelColor;

		if (theme === 'dark') {
			dataLabelColor = '#ffffff';
			labelColor = 'rgba(255,255,255,0.5)';
			lineColor = 'rgba(255,255,255,0.2)';
		} else {
			dataLabelColor = '#242628';
			labelColor = 'hsl(210,5%,55%)';
			lineColor = 'hsl(210,10%,85%)';
		}

		var options = {
			chart : {
				backgroundColor : null,
				spacing : [ 8, 0, 0, 0 ],
				style : {
					fontFamily : '"Source Sans Pro","Helvetica Neue","Helvetica","Arial",sans-serif'
				}
			},
			credits : {
				enabled : false
			},
			lang : {
				thousandsSep : ','
			},
			legend : {
				enabled : false
			},
			plotOptions: {
				area: {
					color: 'hsl(210,100%,40%)',
					fillColor: {
						linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
						stops: [
							[0, 'rgba(128,191,255,0.5)'],
							[1, 'rgba(128,191,255,0)']
						]
					},
					marker: {
						enabled: false,
						symbol: 'circle'
					},
					threshold: null
				},
				column: {
					color: 'hsl(210,100%,40%)',
					dataLabels: {
						inside: false,
						style: {
							color: '#242628',
							fontSize: '18px',
							fontWeight: 'normal'
						}
					}
				},
				line: {
					color: 'hsl(210,100%,40%)',
					marker: {
						symbol: 'circle'
					}
				},
				pie: {
					borderWidth: 3,
					borderColor: '#ffffff',
					dataLabels: {
						enabled: false
					},
					innerSize: 158,
					size: 194,
					slicedOffset: 0,
					states: {
						hover: {
							brightness: -0.1
						}
					}
				},
				series: {
					dataLabels: {
						style: {
							color: dataLabelColor,
						}
					},
					states: {
						hover: {
							enabled: false
						}
					}
				}
			},
			responsive: {
				rules: [{
					condition: {
						minWidth: 480
					},
					chartOptions: {
						tooltip: {
							positioner: function(labelWidth, labelHeight, point) {
								var coords = {
									x: this.chart.plotLeft + point.plotX - (labelWidth / 2),
									y: this.chart.plotTop + point.plotY - labelHeight - 16
								};
								return coords;
							}
						}
					}
				}]
			},
			title : {
				text : null
			},
			tooltip : {
				enabled : false,
				backgroundColor: '#ffffff',
				borderColor: null,
				borderWidth: 0,
				xDateFormat: '%b %e %Y',
				useHTML: true
			},
			xAxis : {
				labels : {
					style : {
						color : labelColor,
						fontSize : '12px'
					}
				},
				lineColor : lineColor,
				tickColor : lineColor,
				title: {
					text : null,
					style: {
						color: labelColor
					}
				}
			},
			yAxis : {
				gridLineColor : lineColor,
				labels : {
					style : {
						color : labelColor,
						fontSize : '12px'
					},
					x : -8

				},
				lineColor : lineColor,
				tickColor : lineColor,
				title : {
					text : null,
					style: {
						color: labelColor
					}
				}
			}
		};

		return options;
	}
})(window.angular);